import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  COLORS_COOLGRAY60,
  COLORS_GREEN,
  COLORS_GREEN20,
  COLORS_GREEN30,
  COLORS_GREEN40,
  COLORS_LIGHTGRAY,
  COLORS_LIGHTGRAYBG,
  COLORS_WHITE,
} from '../../App.constants';
import { BenchmarkBox } from './BenchmarkBox';
import { useLocalStore } from '../local-store-provider/LocalStoreProvider.utils';
import { RevenueCalculatorStore } from '../revenue-calculator/RevenueCalculator.store';
import { observer } from 'mobx-react';
import { SwapHoriz } from '@mui/icons-material';
import { CallToAction } from './call-to-action/CallToAction';
import { isSmall } from '../../utils/utils';

export const Benchmarks: React.FC = observer(() => {
  const localStore = useLocalStore<RevenueCalculatorStore>();

  return (
    <Box
      paddingY={6}
      display={'flex'}
      width={'100%'}
      alignItems={'center'}
      flexDirection={'column'}
      bgcolor={COLORS_LIGHTGRAYBG}
    >
      {!isSmall() && (
        <Box
          width={'100%'}
          display={'flex'}
          alignItems={'center'}
          flexDirection={'column'}
        >
          <SwapHoriz
            style={{ width: '60px', height: '60px', color: COLORS_GREEN }}
            width={'42px'}
            height={'30px'}
          />
        </Box>
      )}

      <Typography
        color={COLORS_GREEN}
        fontWeight={'bold'}
        fontSize={'1.563em'}
        textAlign={'center'}
      >
        {isSmall() && (
          <Box
            width={'40px'}
            height={'40px'}
            display={'inline'}
            marginRight={'8px'}
            marginLeft={'-2px'}
          >
            <SwapHoriz
              style={{ marginBottom: '-10px', marginRight: '-5px', width: '40px', height: '40px', color: COLORS_GREEN }}
            />
          </Box>
        )}
        How do you stack up to industry benchmarks?
      </Typography>

      {!localStore.hasSubmittedEmail && (
        <Typography textAlign={'center'}>
          Enter your email address below to see how you stack up to industry benchmarks for revenue & utilization.
        </Typography>
      )}

      <Grid
        container={true}
        direction={'row'}
        marginTop={4}
        position={'relative'}
      >
        {!localStore.hasSubmittedEmail && <CallToAction />}
        <Grid
          item={true}
          xs={4}
          alignItems={'flex-start'}
          border={'1px solid transparent'}
          bgcolor={COLORS_WHITE}
          paddingLeft={4}
        >
          <Typography
            marginY={2}
            height={'50px'}
            textAlign={'left'}
            letterSpacing={7}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            color={COLORS_COOLGRAY60}
            fontSize={'0.98rem'}
          >
            BENCHMARKS
          </Typography>
          <Typography
            marginY={1.5}
            textAlign={'left'}
          >
            Rev per Billable
          </Typography>
          <Typography
            paddingY={1.5}
            borderTop={`1px solid ${COLORS_LIGHTGRAY}`}
            borderBottom={`1px solid ${COLORS_LIGHTGRAY}`}
            textAlign={'left'}
          >
            Revenue per Employee
          </Typography>
          <Typography
            marginY={1.5}
            textAlign={'left'}
          >
            Target Average Utilization
          </Typography>
        </Grid>
        <BenchmarkBox
          top={localStore.revenuePerBillableEmployee}
          mid={localStore.revenuePerEmployee}
          bottom={localStore.targetAverageUtilization}
          header={'YOUR RESULTS'}
          isHighlighted={localStore.hasSubmittedEmail}
          backgroundColor={'transparent'}
          showValue={localStore.hasSubmittedEmail}
        />

        <BenchmarkBox
          top={104000}
          mid={77000}
          bottom={60}
          header={'LOW'}
          backgroundColor={COLORS_GREEN20}
          showValue={localStore.hasSubmittedEmail}
        />
        <BenchmarkBox
          top={215000}
          mid={175000}
          bottom={75}
          header={'MID'}
          backgroundColor={COLORS_GREEN30}
          showValue={localStore.hasSubmittedEmail}
        />
        <BenchmarkBox
          top={2910000}
          mid={253000}
          bottom={85}
          header={'HIGH'}
          backgroundColor={COLORS_GREEN40}
          showValue={localStore.hasSubmittedEmail}
        />
      </Grid>
    </Box>
  );
});

Benchmarks.displayName = 'Benchmarks';
